const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 424.54807,
    height: 390.3284,
    viewBox: "0 0 424.54807 390.3284",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "swatch2"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#f80000",
      stopOpacity: 1
    },
    offset: 0,
    id: "stop2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer5",
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "#cf0000",
      strokeOpacity: 1
    },
    transform: "translate(-131.42299,-237.55399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g145",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#cf0000",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g133-8",
    style: {
      display: "inline",
      mixBlendMode: "normal",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#cf0000",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(1.4648815,2.7790324)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g24-5",
    transform: "matrix(-1,0,0,0.99285507,1068.86,1.7497841)",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#cf0000",
      strokeWidth: 3.01078,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    d: "m 413.31142,589.51049 100.61508,0.43426 c 2.63509,-0.0129 4.00315,-0.8927 4.6901,-2.59099 0.69234,-1.71161 0.69284,-4.25464 0.69284,-7.57624 l 0.002,-109.59562 0.002,-185.82251 -0.004,105.73989 V 280.16627 c 0,-3.3216 -5e-4,-5.86463 -0.69284,-7.57624 -0.68695,-1.69829 -2.05501,-2.57806 -4.7531,-2.58995 l -37.75691,10e-4 c -3.17608,0.013 -4.81665,0.8951 -5.64044,2.59797 -0.83025,1.71622 -0.83085,4.26611 -0.83085,7.59666 l -7.8e-4,109.56518 -0.0191,135.33102 c -0.0183,18.00549 -27.6303,25.97257 -40.62469,6.83172 L 240.89401,269.888 l -70.76305,0.11237 c -2.56852,0.0114 -3.93658,0.89117 -4.62353,2.58946 -0.69234,1.71161 -0.69284,4.25464 -0.69284,7.57624 l 0.0146,109.75642 c -0.15294,5.10087 0.77713,9.882 -4.93727,9.882 l -22.84275,0.002 -2.13962,0.002 c -5.7144,0 -4.78433,-4.78113 -4.95144,-9.99582 l 4.1e-4,-135.00568 0.008,0.0202 c 0.0319,-7.86642 2.96431,-14.45661 8.84502,-17.70207 4.03235,-2.22539 9.38624,-2.34783 16.39992,-2.34783 l -0.10331,0.003 63.75835,0.002 19.9051,0.0125 c 18.8371,-0.0191 19.13471,2.73684 25.31911,9.74121 l 155.52935,216.02383 c 5.89111,9.00014 9.81048,13.64694 14.95451,13.96336 l -0.187,-219.81246 c 0.0255,-7.74966 2.95792,-14.33985 8.83863,-17.58531 4.03235,-2.22539 9.38624,-2.34746 16.18801,-2.35046 l 70.01619,0.0707 c 6.81706,0.004 12.17095,0.1258 16.2033,2.33529 5.88071,3.22227 8.81307,9.76538 8.84477,17.55483 l 0.0277,350.52434 c -0.0349,7.73421 -2.9673,14.27731 -8.84801,17.49958 -4.03235,2.20949 -9.38624,2.33106 -16.22555,2.32948 l -114.44242,-0.002 -0.004,0.0162 c -18.8371,0 -19.13192,-2.75624 -25.32006,-9.76806 L 275.68767,459.60102 m 0.11565,0.18636 c -2.69722,-4.54756 -6.05321,-8.08477 -1.2335,-11.16254 l 20.61362,-13.16489 117.33399,152.99807 C 410.99722,589.4288 396.83118,576.98257 378.14905,559.48775 337.609,521.52414 275.80332,459.78738 275.80332,459.78738 Z m 19.83547,-24.62121 c 4.81973,-3.07776 6.60685,1.46131 9.58664,5.82842 L 413.49775,589.33092 305.21963,440.99357 c -1.72576,0.33461 113.91284,152.32866 107.4829,149.36525 L 292.4827,437.18002 c 1.05203,-0.67128 2.10406,-1.34257 3.15609,-2.01385 z",
    id: "use37-5"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "translate(-131.42299,-237.55399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g132-4",
    transform: "translate(-2.0353963,-39.220968)",
    style: {
      display: "inline",
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect115-1",
    width: 31.461246,
    height: 31.543432,
    x: 136.74756,
    y: 631.70331
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect120-2",
    width: 31.461246,
    height: 31.543432,
    x: 216.74756,
    y: 631.70331
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect121-0",
    width: 31.461246,
    height: 31.543432,
    x: 136.74756,
    y: 556.67548
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect122-0",
    width: 31.461246,
    height: 31.543432,
    x: 216.74756,
    y: 556.67548
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect124-1",
    width: 31.461246,
    height: 31.543432,
    x: 136.74756,
    y: 481.67499
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect125-4",
    width: 31.461246,
    height: 31.543432,
    x: 216.74756,
    y: 481.67499
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 3,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 0,
      strokeDasharray: "none",
      strokeOpacity: 1,
      paintOrder: "stroke fill markers"
    },
    id: "rect126-6",
    width: 31.461246,
    height: 31.543432,
    x: 216.74756,
    y: 406.64682
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/IconWhite.7549f18c2360521bdfa0a51fbea057f5.svg";
export { ForwardRef as ReactComponent };